import { createFileRoute } from '@tanstack/react-router'
import { PAXDetailView } from '@/components/PAXDetailView'

export const Route = createFileRoute('/_auth/pax/$paxId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { paxId } = Route.useParams()

  return <PAXDetailView passengerId={paxId} />
}
